import * as ReactDOM from "react-dom";

import "./bootstrap-full-app.scss";

import {parseUrlQuery} from "@Common/utils/parse-url-query";

import "./common/wrap-date";
import {App}             from "./app";
import {listingParams}   from "./routes/listing-params";

export const bootstrapFullApp = (rootDom) => {

    const a = parseUrlQuery(window.location.search) || {};

    if(!a["listingId"])
    {
        for (let i = 0; i < listingParams.length; i++) {
            const listingParam = listingParams[i];
            setLS(listingParam, a[listingParam]);
        }
    }
    else
    {
        for (let i = 0; i < listingParams.length; i++) {
            const listingParam = listingParams[i];
            addLS(listingParam, a[listingParam]);
        }
    }

    ReactDOM.render(App(), rootDom);
};

function setLS(key, value) {
    if (value == null) {
        sessionStorage.removeItem(key);
    } else {
        sessionStorage.setItem(key, value);
    }
}

function addLS(key, value) {
    if (value != null) {
        sessionStorage.setItem(key, value);
    }
}

window.disposeScript = () => {
    let rootDom = document.getElementById('root');
    ReactDOM.render(null, rootDom);
    console.clear();
    rootDom.remove();
    rootDom = document.createElement("div");
    rootDom.id = "root";
    document.body.appendChild(rootDom);
};
